<template>
    <UploadDocumentosShared ref="uploadDocumentosShared" :Edicao="Edicao" />
</template>

<script>
import UploadDocumentosShared from "@/views/Cadastro/Shared/UploadDocumentos.vue";

export default {
  name: "CadastroPF_UploadDocumentos",
  components: { UploadDocumentosShared },
  props: ["Edicao"],
  methods: {
    proximaEtapa() {
      if (this.$refs.uploadDocumentosShared?.proximaEtapa) {
        this.$refs.uploadDocumentosShared.proximaEtapa();
      }
    },
    salvarInformacoes() {
      return this.$refs.uploadDocumentosShared?.salvarInformacoes?.();
    },
    validarFormulario(submeter) {
      if (this.$refs.uploadDocumentosShared) {
        return this.$refs.uploadDocumentosShared.validarFormulario(submeter);
      }
      return true;
    },
  },
};
</script>
